import { render, staticRenderFns } from "./BannerSidebar.vue?vue&type=template&id=381b60fc&"
import script from "./BannerSidebar.vue?vue&type=script&lang=js&"
export * from "./BannerSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports